// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderList-root_GdGbj"};